module.exports = __webpack_public_path__ + "img/tinder.64116a7.jpg";